exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-steps{\r\n    width: 100%;\r\n    overflow: auto;\r\n}\r\n.container-steps::-webkit-scrollbar:horizontal {     \r\n    height: 7px; \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-tecnicas-modal/renta-laboral-tecnicas-modal.component.css
// module id = ../../../../../src/app/components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-tecnicas-modal/renta-laboral-tecnicas-modal.component.css
// module chunks = main